import { z } from 'zod'

export const operationalExpenseSchema = z.object({
  categoryId: z.string().min(1, 'Selecione uma categoria'),
  accountId: z.string().min(1, 'Selecione uma conta'),
  vehicleId: z.string().optional().nullable(),
  freightId: z.string().optional().nullable(),
  amount: z.coerce
    .number({ error: 'Valor inválido' })
    .positive('Valor deve ser positivo'),
  date: z.string().min(1, 'Informe a data da despesa'),
  description: z.string().min(1, 'Descrição obrigatória').max(200),
  supplier: z.string().max(120).optional().nullable(),
  documentNumber: z.string().max(60).optional().nullable(),
  method: z.enum(['PIX', 'BANK_TRANSFER', 'BANK_SLIP', 'CASH', 'OTHER']),
  notes: z.string().max(500).optional().nullable(),
})

export type OperationalExpenseFormData = z.infer<typeof operationalExpenseSchema>
